/** Reports > Warehouse (RSW / CSW): RSW and CSW reports as one list (user, 2026-10-16). */
import { WAREHOUSE_STAGE_REPORTS, openStages } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { StageReportsIndexPage } from "@/features/warehouse/reports/stage-reports-pages";

export const Route = createFileRoute("/_app/reports/warehouse/")({
  // Any warehouse report's own code, at any stage, opens the list.
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!WAREHOUSE_STAGE_REPORTS.some((r) => openStages(r, can).length))
      throw redirect({ to: "/reports" });
  },
  component: StageReportsIndexPage,
});
